import { useQueryClient as s, useMutation as o } from "@tanstack/vue-query";
import { rotatorCampaignKeys as u } from "./queries.js";
const y = (n, e) => {
  const r = s(), t = e?.onSuccess;
  return o({
    ...e,
    mutationFn: async (a) => n.rotatorCampaign.create(a.body),
    onSuccess: async (...a) => {
      await r.invalidateQueries({ queryKey: u.all }), t && t(...a);
    }
  });
}, m = (n, e) => {
  const r = s(), t = e?.onSuccess;
  return o({
    ...e,
    mutationFn: async (a) => n.rotatorCampaign.update(a.body),
    onSuccess: async (...a) => {
      await r.invalidateQueries({ queryKey: u.all }), t && t(...a);
    }
  });
}, l = (n, e) => {
  const r = s(), t = e?.onSuccess;
  return o({
    ...e,
    mutationFn: async (a) => n.rotatorCampaign.remove({ rotatorCampaignId: a.rotatorCampaignId }),
    onSuccess: async (...a) => {
      await r.invalidateQueries({ queryKey: u.all }), t && t(...a);
    }
  });
};
export {
  y as useCreateRotatorCampaign,
  l as useDeleteRotatorCampaign,
  m as useUpdateRotatorCampaign
};
//# sourceMappingURL=mutations.js.map
